<hr class="mt-0" />
<form [formGroup]="form" (submit)="onSave()" class="w-full">
  <div class="flex flex-column gap-2 mb-4">
    <label emRequiredMark for="name">{{ 'layout.configurations.regions.labels.regionNameEn'| translate }}</label>
    <input id="name" formControlName="name" type="text" pInputText
      [placeholder]="'layout.configurations.regions.placeholders.regionNameEn'| translate" class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('name').invalid }" />
    <div *ngIf="isInvalid('name').invalid" class="text-red-600">{{ isInvalid('name').message | translate }}</div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('name') | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label emRequiredMark for="nameEs">{{ 'layout.configurations.regions.labels.regionNameEs'| translate }}</label>
    <input id="nameEs" formControlName="nameEs" type="text" pInputText
      [placeholder]="'layout.configurations.regions.placeholders.regionNameEs'| translate" class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('nameEs').invalid }" />
    <div *ngIf="isInvalid('nameEs').invalid" class="text-red-600">{{ isInvalid('nameEs').message | translate }}</div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('nameEs') | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label emRequiredMark for="nameAr">{{ 'layout.configurations.regions.labels.regionNameAr'| translate }}</label>
    <input id="nameAr" formControlName="nameAr" type="text" pInputText
      [placeholder]="'layout.configurations.regions.placeholders.regionNameAr'| translate" class="w-full" dir="rtl"
      [ngClass]="{ 'p-invalid': isInvalid('nameAr').invalid }" />
    <div *ngIf="isInvalid('nameAr').invalid" class="text-red-600">{{ isInvalid('nameAr').message | translate }}</div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('nameAr') | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label emRequiredMark for="code">{{ 'layout.configurations.regions.code' | translate }}</label>
    <input id="code" formControlName="code" type="text" pInputText
      [placeholder]="'layout.configurations.regions.placeholders.regionCode'| translate" class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('code').invalid }" />
    <div *ngIf="isInvalid('code').invalid" class="text-red-600">{{ isInvalid('code').message | translate }}</div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('code') | translate }}</div>
  </div>
  <hr />
  <div class="flex justify-content-end mb-4">
    <p-button type="submit" icon="pi pi-check"
      [label]="'layout.configurations.regions.addRegion.save' | translate"></p-button>
  </div>
</form>